/**
 * WHAT TO SAY WHEN A WRITE IS REFUSED.
 *
 * THE RULE THIS FILE ENFORCES BY EXISTING: a refused write must never look like a success. Two
 * screens have now cost a release cycle to that exact bug — the lottery's `record` button, whose
 * rejection was swallowed by a bare `void` while the page carried on saying the draw had not run,
 * and the ranking's `Resubmit`, which stamped the new time into React state BEFORE the write and
 * so said "Submitted just now" whether or not anything reached the database.
 *
 * A permission error is called out by name because it has one cause here and one fix, and the fix
 * is not something a manager can do: the security rules on the deployed project are older than the
 * code talking to them. Saying so turns "the button doesn't work" into a release.
 */
export function writeFailed(err: unknown): string {
  const msg = err instanceof Error ? err.message : String(err);
  if (/permission|insufficient/i.test(msg)) {
    return 'The database refused the write. Either you are not allowed to write this, or the '
      + 'security rules have not been deployed since this was built — re-run the release. '
      + `(${msg})`;
  }
  if (/offline|network|unavailable|failed to fetch/i.test(msg)) {
    return `That did not save — the app could not reach the database. (${msg})`;
  }
  return `That did not save: ${msg}`;
}
